<template>
   <div class='detail-bill'>
      <div class="detail-bill-head">
         <h2 class="detail-bill-month">{{$d(billInfo.ts1000,'tiny')}}</h2>
         <!-- <h2 class="detail-bill-month">{{$d(1625053673145,'tiny')}}</h2> -->
         <!-- <h2 class="detail-bill-month">{{billInfo.ts | formatDate('yyyy年MM月')}}</h2> -->
         <div class="detail-bill-price">
            <!-- 5月账单金额 -->
            <div class="detail-bill-date">{{$t('bstext.bs18',{msg:billInfo.tsMonth})}}</div>
            <!-- <div class="detail-bill-date">{{billInfo.ts | formatDate('MM') | removeLeftZero}}月账单金额</div> -->
            <div class="detail-bill-account"><span>{{billInfo.currencySymbol}}</span>{{billInfo.amount | formatPrice}}</div>
         </div>
      </div>
      <div class="detail-bill-body">
         <div class="detail-bill-box">
            <!-- 套餐费用 -->
            <h2 class="detail-bill-cost"><span>{{$t('bstext.bs19')}}</span><span class="ml5">{{billInfo.currencySymbol}}{{billInfo.serviceAmount | formatPrice}}</span></h2>
            <div class="detail-bill-content" v-for="(item,index) in billInfo.serviceInfo" :key="index">
               <!-- 单电套餐':'双电套餐  -->
               <p class="detail-bill-name"><span>{{item.name}}{{item.battAmount==1?$t('bstext.bs20'):$t('bstext.bs21')}}</span><i class="ml5">{{billInfo.currencySymbol}}{{item.amount | formatPrice}}</i></p>
               <p class="detail-bill-cycle">{{item.staTime | formatDate('yyyy.MM.dd')}}-{{item.endTime | formatDate('yyyy.MM.dd')}}</p>
            </div>
         </div>
         <div class="detail-bill-box">
            <!-- 换电费用 -->
            <h2 class="detail-bill-cost"><span>{{$t('bstext.bs22')}}</span><span class="ml5">{{billInfo.currencySymbol}}{{billInfo.battAmount | formatPrice}}</span></h2>
            <div class="detail-bill-content">
               <!-- 本月换电总安时(安时) 本月付费换电量-->
               <div class="detail-bill-name mb0"><span class="en-break-all">{{$t('bstext.bs23')}}</span><i class="ml5">{{billInfo.dosage}}kWh</i></div>
            </div>
         </div>
         <!-- 0729 李鹏暂时去掉这个 变更费用暂时关闭 -->
         <div class="detail-bill-box" v-if="false">
         <!-- <div class="detail-bill-box" v-if="billInfo.exchangeAmount"> -->
            <!-- 变更费用 -->
            <h2 class="detail-bill-cost"><span>{{$t('bstext.bs25')}}</span><span class="ml5">{{billInfo.currencySymbol}}{{billInfo.exchangeAmount | formatPrice}}</span></h2>
            <div class="detail-bill-content">
               <!-- 升级费用 -->
               <p class="detail-bill-name mb0"><span>{{$t('bstext.bs26')}}</span><i class="ml5">{{billInfo.currencySymbol}}{{billInfo.exchangeAmount | formatPrice}}</i></p>
            </div>
         </div>
         <div class="pay-way" v-if="billInfo.status!=payStatus.nonPaid&&billInfo.status!=payStatus.overdue">
            <!-- 支付时间 -->
            <p><span>{{$t('bstext.bs27')}}:</span>{{billInfo.payTime | formatDate('yyyy.MM.dd hh:mm:ss')}}</p>
            <!-- 支付方式 -->
            <p><span>{{$t('bstext.bs28')}}:</span>{{billInfo.payMethod | formatStatus(payMethods)}}</p>
         </div>
         <!-- 暂时都不要了 -->
         <div class="cost-info" v-if="false">
            <!-- 资费说明 -->
            <h2>{{$t('bstext.bs29')}}:</h2>
            <!-- 账单费用=套餐费用+换电费用+变更费用 -->
            <p>{{$t('bstext.bs30')}}</p>
            <!-- 套餐费用=月套餐固定费用(不足一天按天折算) -->
            <p>{{$t('bstext.bs31')}}</p>
            <!-- 换电费用=周期内付费换电总安时*2元 -->
            <p>{{$t('bstext.bs32')}}</p>
            <!-- 变更费用=超3个月升级费用 -->
            <p>{{$t('bstext.bs33')}}</p>
         </div>
         <div class="pay-btn-box" v-if="billInfo.status==payStatus.nonPaid||billInfo.status==payStatus.overdue">
            <!-- 去支付 -->
            <bs-button class="w100" @click="payBill">{{$t('bstext.bs34')}}</bs-button>
         </div>
      </div>
   </div>
</template>

<script>
import utils from '@/utils/index'
export default {
   data () {
      return {
         billInfo:{},
         payMethods:[],
         non:this.$route.params.id,
         lang:localStorage.getItem('lang')          
      }
   },
   computed:{
      payStatus(){
         return this.$store.state.payStatus
      },
      month(){
         return this.$store.state.month
      }
   },
   mounted() {
      document.title = this.$t('bstext.bs44')
      this.payMethods=this.$t('bsstatus.payMethods')
      this.getBillInfo()
   },
   methods: {
      getBillInfo(){
         this.$appApi.nativeLoading(true,'',0)
         let req ={
            ono:this.non
         }
         this.$server.getBillInfo(req).then(res=>{
            let info =res.data
            const tsMonth=parseInt(utils.formatDate(info.ts,'MM'))
            info.tsMonth=this.lang=='en'?this.month[tsMonth]:tsMonth
            info.ts1000=info.ts*1000
            document.title = this.$t('bstext.bs18',{msg:info.tsMonth})
            this.billInfo=info
         }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      },
      payBill(){
         this.$store.commit('SET_FLAG',2)
         this.$router.push(`/bs/battswap/payway?ono=${this.ono}`)
      }
   }
}
</script>

<style lang='less' scoped>
.detail-bill{
   background: #F7F8FA;
   min-height: 100vh;
   .detail-bill-head{
      position: relative;
      // box-sizing: border-box;
      padding: 24px 20px;
      height: 70px;
      background: #21242C;
      .detail-bill-month{
         padding-left: 4px;
         font-size: 18px;
         font-weight: 500;
         color: #FFFFFF;
         line-height: 25px;
      }
      .detail-bill-price{
         position: absolute;
         left: 20px;
         top: 70px;
         width: calc(100vw - 40px);
         box-sizing: border-box;
         padding: 16px 16px 24px;
         background: #2E68F6;
         border-radius: 2px;
         .detail-bill-date{
            margin-bottom: 16px;
            font-size: 16px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 22px;
         }
         .detail-bill-account{
            font-size: 32px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 32px;
            span{
               margin-right: 6px;
               font-size: 16px;
               line-height: 22px;
            }
         }
      }
   }
   .detail-bill-body{
      padding: 92px 20px 20px;
      .detail-bill-box{
         margin-bottom: 24px;
         .detail-bill-cost{
            display: flex;
            justify-content: space-between;
            padding:0 12px 0 4px;
            margin-bottom: 12px;
            font-weight: 600;
            color: #21242C;
            line-height: 22px;
            span{
               font-size: 16px;
            }
         }
         .detail-bill-content{
            background: #FFFFFF;
            border-radius: 2px;
            padding: 12px;
            margin-bottom: 8px;
            .detail-bill-name{
               display: flex;
               justify-content: space-between;
               color: #21242C;
               line-height: 20px;
               margin-bottom: 8px;
            }
            .detail-bill-cycle{
               color: #8F95A3;
               line-height: 20px;
            }
            .mb0{
               margin-bottom: 0;
            }
         }
      }
      .pay-way{
         color: #8F95A3;
         line-height: 20px;
         padding: 0 4px;
         margin-bottom: 32px;
         span{
            margin-right: 5px;
         }
      }
      .cost-info{
         color: #8F95A3;
         line-height: 20px;
         padding: 0 4px 0;
         h2{
            margin-bottom: 8px;
            font-weight: normal;
         }
      }
      .pay-btn-box{
         margin: 32px 20px 20px;
      }      
   }
}
</style>


// WEBPACK FOOTER //
// src/components/blueshark/battswap/mybill/billdetail.vue